module.exports = __webpack_public_path__ + "img/L1060785.f635a22a.jpg";